import AdminLayout from '../../../components/AdminLayout'
import { WorkForm } from '../../../components/WorkForm'
import { withUser } from '../../../components/withUser'

const NewWork: React.FC = () => (
  <AdminLayout>
    <WorkForm />
  </AdminLayout>
)

export default withUser(NewWork)
